<script setup lang="ts">
import {ref} from "vue";
import {Button} from "@/Components/Library";
import User from "@/Models/User";
import LaunchHeader from "@/Pages/User/Questions/Launch/LaunchHeader.vue";
import {useMainStore} from "@/Stores/store";
import {useConfirm} from "primevue/useconfirm";
import {useToast} from "primevue/usetoast";
import {exportMultipleQuestions} from "@/Services/responses";

const confirm = useConfirm();
const toast = useToast();
const $user = new User();
const $store = useMainStore();

const {state, params} = defineProps<{
    state: {
        actionDialog: {
            visible: boolean;
            actionText: string;
            itemText: string;
        };
        show: {
            shareDialog: boolean;
        };
    };
    params: {
        filter: {
            group_id: string[];
        };
    };
}>();
const emit = defineEmits<{
    (e: "cancel"): void;
}>();

const exportLoading = ref(false);

const handleAnalyzeMultiple = async () => {
    confirm.require({
        header: "Analyze posts responses",
        message: `Are you sure you want to analyze responses from ${$store.selectedQuestions.length} post(s)?`,
        acceptClass: "bg-askr-green text-white px-2 py-1 rounded-lg hover:brightness-110",
        rejectClass: "px-2 py-1 hover:brightness-110",
        accept: async () => {
            try {
                state.actionDialog = {
                    visible: true,
                    actionText: "Analyzing",
                    itemText: $store.selectedQuestions.length === 1 ? "post" : "posts",
                };

                // TODO: Flesh out logic

                emit("cancel");
            } catch (e) {
                console.error(e);
            } finally {
                state.actionDialog.visible = false;
            }
        },
    });
};

const handleExport = async () => {
    try {
        exportLoading.value = true;

        const response = await exportMultipleQuestions({
            question_ids: $store.selectedQuestions,
            group_ids: params.filter.group_id.length ? params.filter.group_id : null,
        });

        window.location.href = route("files.download", response.path);

        toast.add({
            severity: "success",
            summary: "Export started",
            detail: `Responses for ${$store.selectedQuestions.length} post(s) exported successfully.`,
            life: 3000,
        });
    } catch (error) {
        console.error(error);
    } finally {
        exportLoading.value = false;
    }
};
</script>

<template>
    <LaunchHeader title="Select posts" class="mb-4" @cancel="emit('cancel')">
        <template #header>
            <div class="ml-auto flex items-center gap-3">
                <Button
                    v-if="!!$store.selectedQuestions.length"
                    icon="mdi:file-delimited-outline"
                    class="bg-white !px-2 !py-1 text-xs text-askr-green hover:brightness-90"
                    size="small"
                    :loading="exportLoading"
                    @click="handleExport"
                >
                    Export
                </Button>
                <!--                <Button-->
                <!--                    v-if="!!$store.selectedQuestions.length && $user.hasRole('super-admin')"-->
                <!--                    icon="prime:sparkles"-->
                <!--                    class="bg-white !px-2 !py-1 text-xs text-askr-green hover:brightness-90"-->
                <!--                    size="small"-->
                <!--                    @click="handleAnalyzeMultiple"-->
                <!--                    :disabled="state.actionDialog.visible"-->
                <!--                >-->
                <!--                    Analyze-->
                <!--                </Button>-->
                <p v-if="!$store.selectedQuestions.length" class="py-0.5">Select posts</p>
            </div>
        </template>
    </LaunchHeader>
</template>

<style scoped></style>
